
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  changePasswordButton: {
    id: "ChangePassword.button",
    defaultMessage: "Update Password",
  }, 
});

export default MESSAGES;